import { useInfiniteQuery } from "@tanstack/react-query";
import type { QueryFunctionContext } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

export interface IReactionListItem {
	id: number;
	name: string;
	reaction: string;
	user: string | null;
	social_post: number | null;
	reaction_date: string;
}

const PAGE_SIZE = 20;

const fetchPostReactions = async (
	postId: string,
	reaction: string | null,
	nextPageUrl?: string
) => {
	const url = nextPageUrl ?? `/social-posts/${postId}/all-reactions/`;
	const params: Record<string, string | number> = {};
	if (!nextPageUrl) {
		params.page = 1;
		params.page_size = PAGE_SIZE;
		if (reaction) params.reaction = reaction;
	}
	const { data } = await cmsClient.get<CMSPaginatedData<IReactionListItem>>(
		url,
		{ params: nextPageUrl ? undefined : params }
	);
	return data;
};

const usePostReactions = (
	postId: string,
	reaction: string | null,
	enabled: boolean
) => {
	return useInfiniteQuery({
		queryKey: ["post-reactions", postId, reaction ?? "all"],
		queryFn: (context: QueryFunctionContext) =>
			fetchPostReactions(postId, reaction, context.pageParam),
		getNextPageParam: (lastPage: CMSPaginatedData<IReactionListItem>) =>
			lastPage.next ?? undefined,
		enabled: enabled && Boolean(postId)
	});
};

export default usePostReactions;
